module.exports = "<div id=\"unauthorized\">\n  <uh-oh-message class=\"uh-oh-message\" message=\"You do not have permission to view this page.\" action-1=\"unauthorized.goBack\">\n    <!-- <button class=\"btn btn-primary animated fadeInUp\" ng-click=\"action1($event)\">Go Back</button> -->\n    If this problem persists please <a href=\"#\" ng-click=\"openSupport($event)\">notify us</a>.\n  </uh-oh-message>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/unauthorized/unauthorized.html
// module id = 1204
// module chunks = 0